import { combineReducers } from 'redux'
import { getUrlParams } from 'utils'

import {
  SHOW_BACK_BUTTON,
  KEY,
  FETCH_WEB_SOCKET_SESSION_ID,
  TOGGLE_APP_VISIBILITY,
  INITIALISE_APP,
  SET_APP_LOCALE,
  WS_CONNECTED,
  WS_DISCONNECTED,
  APP_CLEAR_ERROR,
  APP_SHOW_ERROR,
  MODAL_LOCATION,
  UPDATE_ROUTE,
  URLS,
  SET_IS_MOBILE,
} from '../constants'

const showBackButton = (state = false, action) => {
  switch (action.type) {
    case SHOW_BACK_BUTTON:
      return action.value
    default:
      return state
  }
}
const webSocketId = (state = '', { type, payload }) => {
  switch (type) {
    case FETCH_WEB_SOCKET_SESSION_ID:
      return payload
    default:
      return state
  }
}

const isAppExpanded = (state = false, { type, value }) => {
  switch (type) {
    case TOGGLE_APP_VISIBILITY:
      return value
    default:
      return state
  }
}

const isAppInitialised = (state = false, { type, value }) => {
  switch (type) {
    case INITIALISE_APP:
      return value
    default:
      return state
  }
}

const localeProvider = (state = '', { type, locale }) => {
  switch (type) {
    case SET_APP_LOCALE:
      return locale
    default:
      return state
  }
}

const wsConnected = (state = false, { type, locale }) => {
  switch (type) {
    case WS_CONNECTED:
      return true
    case WS_DISCONNECTED:
      return false
    default:
      return state
  }
}

const route = (state = { main: URLS.PRE_CHAT, sub: '' }, { type, value }) => {
  switch (type) {
    case UPDATE_ROUTE:
      return value
    default:
      return state
  }
}

const isMobile = (
  state = getUrlParams().isMobile === 'true',
  { type, value }
) => {
  switch (type) {
    case SET_IS_MOBILE:
      return value
    default:
      return state
  }
}

const initialModalState = {
  isShown: false,
  message: '',
  cta1: '',
  cta2: '',
  placeholder: '',
  location: MODAL_LOCATION.PRE_CHAT,
}
const modal = (state = initialModalState, { type, payload }) => {
  switch (type) {
    case APP_SHOW_ERROR:
      return Object.assign({}, state, {
        isShown: true,
        message: payload.message,
        cta1: payload.cta1,
        cta2: payload.cta2,
        placeholder: payload.placeholder,
        location: payload.location,
        code: payload.code,
      })
    case APP_CLEAR_ERROR:
      return Object.assign({}, state, {
        isShown: false,
        message: '',
        cta1: '',
        cta2: '',
        placeholder: '',
        location: '',
        code: '',
      })
    default:
      return state
  }
}

export const appReducer = combineReducers({
  showBackButton,
  webSocketId,
  isAppExpanded,
  isAppInitialised,
  locale: localeProvider,
  wsConnected,
  modal,
  route,
  isMobile,
})

export const getWebSocketId = state => state.app.webSocketId
export const getLocale = state => state.app.locale
export const isBackButtonAvailable = state => state.app.showBackButton
export const getIsAppInitialised = state => state.app.isAppInitialised
export const getIsAppExpanded = state => state.app.isAppExpanded
export const getRoute = state => state.app.route
export const getIsMobile = state => state.app.isMobile



// WEBPACK FOOTER //
// ./src/containers/App/appReducer.js